export const apiUrl = {
  ACG_SEVICEURL: `https://aicaigoufuwuapi.yiwangtui.com/`, // 爱采购运营助手
  // ACG_SEVICEURL: `http://192.168.0.12:6017/`, // 爱采购运营助手测试/
  QXL_SEVICEURL: `https://businesspioneerapi.yiwangtui.com/` //商机先锋
  // QXL_SEVICEURL: `https://businesspioneerapi-beta.yiwangtui.com/` //商机先锋测试
}
